import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from '../../services/auth';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-setup-mfa',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSnackBarModule
  ],
  templateUrl: './setup-mfa.html',
  styleUrls: ['./setup-mfa.scss']
})
export class SetupMFA implements OnInit {
  qrCodeUrl: string | null = null;
  studioUserId: string | null = null;

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // ✅ Get QR code URL from session storage
    this.qrCodeUrl = sessionStorage.getItem('mfaQrCodeUrl');
    this.studioUserId = sessionStorage.getItem('setupMfaUserId');

    // ✅ Redirect if no QR code found
    if (!this.qrCodeUrl || !this.studioUserId) {
      this.snackBar.open('Session expired. Please login again.', '', { duration: 3000 });
      this.router.navigate(['/login']);
    }
  }

  /**
   * ✅ Proceed to OTP verification after QR code scan
   */
  proceedToVerification(): void {
    this.snackBar.open('Please enter the 6-digit code from your authenticator app', '', { 
      duration: 3000 
    });

    // ✅ Navigate to MFA login page for first-time verification
    this.router.navigate(['/MFALogin']);
  }

  /**
   * ✅ Skip setup for now (optional - can remove if mandatory)
   */
  skipSetup(): void {

    this.snackBar.open('You can setup MFA later from your profile settings', '', { 
      duration: 4000 
    });

    // Clear session data
    sessionStorage.removeItem('mfaQrCodeUrl');
    sessionStorage.removeItem('setupMfaUserId');
    sessionStorage.removeItem('loginSession');

    // Redirect to login
    this.router.navigate(['/login']);
  }
}
